async function asyncForEach (array, callback) {
	for (let index = 0; index < array.length; index++) {
		await callback(array[index], index, array)
	}
}

function searchToObject (search) {
	return search.substring(1).split('&').reduce(function (result, value) {
		var parts = value.split('=')
		if (parts[0]) result[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1])
		return result
	}, {})
}

function langToObject (lang) {
	const obj = {}
	const langs = Object.keys(lang)
	langs.forEach(key => {
		obj[key] = {}
	})
	langs.forEach(key => {
		lang[key].forEach(text => {
			obj[key][text.value] = text.name
		})
	})
	return obj
}

export {
	asyncForEach,
	searchToObject,
	langToObject
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/src/utils/index.js